import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import LineCrownIcon from 'LuxKit/Icons/line/LineCrownIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import React from 'react'
import type { IntlShape } from 'react-intl'

export function getHotelValueContentSection(intl: IntlShape) {
  return [
    {
      key: 'bestPrice',
      heading: intl.formatMessage({
        id: 'lCgksbjPMe',
        defaultMessage: 'Best price guarantee',
        description: 'Promotional text for the best price guarantee badge displayed on offer cards',
      }),
      body: intl.formatMessage({
        id: 'UX/D5ePDoH',
        defaultMessage: 'We negotiate the best prices so you don’t have to. If you find a better price, we’ll match it.',
        description: 'Body text for best price guarantee value proposition',
      }),
      icon: <LineUsdCircleIcon />,
      show: true,
      link: {
        text: intl.formatMessage({
          id: 'cjhiiA2rYd',
          defaultMessage: 'Learn more',
          description: 'Hyperlink text to learn more about a feature on the offer types landing page',
        }),
        href: '/best-price-guarantee',
      },
    },
    {
      key: 'changeOfMind',
      heading: intl.formatMessage({
        id: 'gn3lcDU6m2',
        defaultMessage: '7-day change of mind refund',
        description: 'Heading for 7-day change of mind refund value proposition',
      }),
      body: intl.formatMessage({
        id: 'FZuMY1fd/Q',
        defaultMessage: 'Get a full refund on your booking (excludes cruises, flights, travel protection and the service fee paid on deposit bookings)',
        description: 'Body text for 7-day change of mind refund value proposition',
      }),
      icon: <LineClockDollarIcon />,
      show: true,
    },
    {
      key: 'buyNowChooseLater',
      heading: intl.formatMessage({
        id: 'syvhb+ek4s',
        defaultMessage: 'Buy now, choose dates later',
        description: 'Heading for buy now choose dates later value proposition',
      }),
      body: intl.formatMessage({
        id: '69Tg0Wbo4b',
        defaultMessage: 'Lock in a deal today, choose dates when you’re ready',
        description: 'Body text for buy now choose dates later value proposition',
      }),
      icon: <LineCalendarIcon />,
      show: true,
      link: {
        text: intl.formatMessage({
          id: 'cjhiiA2rYd',
          defaultMessage: 'Learn more',
          description: 'Hyperlink text to learn more about a feature on the offer types landing page',
        }),
        href: '/buy-now-book-later',
      },
    },
    {
      key: 'vipInclusion',
      heading: intl.formatMessage({
        id: 'idkrOMASxF',
        defaultMessage: 'VIP Inclusions',
        description: 'Heading for VIP inclusions value proposition in the inclusions list',
      }),
      body: intl.formatMessage({
        id: 'iUFturk/Jo',
        defaultMessage: 'You get a lot more than just a bed in a room',
        description: 'Body copy text for VIP inclusions value proposition',
      }),
      icon: <LineCrownIcon />,
      show: true,
    },
  ]
}
